import ApiService from "./api-service";

class StretchLiveApiService extends ApiService {
    constructor() {
        super();
    }

    setStretchLiveApiClient(stretchLiveApiClient) {
        this.remoteDataStrategy.setStretchLiveApiClient(stretchLiveApiClient);
    }

    async getStreamSrcById(id) {
        return this.dataStrategy.getStreamSrcById(id);
    }
}

export default new StretchLiveApiService();
